<div class="col-sm-2 key-log-filter">
    <div class="key-log-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="key-log-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="residentCheckbox" #residentCheckbox (change)="changeFilter()">
                <label for="residentCheckbox"><svg-checked></svg-checked></label>
                <span>Resident</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="staffCheckbox" #staffCheckbox (change)="changeFilter()">
                <label for="staffCheckbox"><svg-checked></svg-checked></label>
                <span>Staff</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="approvedCheckbox" #approvedCheckbox (change)="changeFilter()">
                <label for="approvedCheckbox"><svg-checked></svg-checked></label>
                <span>Approved</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="pendingCheckbox" #pendingCheckbox (change)="changeFilter()">
                <label for="pendingCheckbox"><svg-checked></svg-checked></label>
                <span>Pending</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="rejectCheckbox" #rejectCheckbox (change)="changeFilter()">
                <label for="rejectCheckbox"><svg-checked></svg-checked></label>
                <span>Reject</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="expiredCheckbox" #expiredCheckbox (change)="changeFilter()">
                <label for="expiredCheckbox"><svg-checked></svg-checked></label>
                <span>Expired</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/classifieds-filter/classifieds-filter.component.html